/**
 * Unticks the "select all" header checkbox and every row checkbox in a table.
 *
 * The row checkboxes rendered by the list pages are uncontrolled inputs, so
 * clearing the React selection state alone leaves them visually ticked.
 */
export const clearTableCheckboxes = () => {
  const checkAll: any = document.getElementById("checkBoxAll");
  if (checkAll) checkAll.checked = false;

  document.querySelectorAll(".tableCheckbox").forEach((element: any) => {
    element.checked = false;
  });
};
